import { requireElement } from '../dom';

export class ToastController {
  private timer: number | null = null;
  private readonly element = requireElement<HTMLElement>('#toast');

  show(message: string, seconds = 1.8): void {
    this.element.textContent = message;
    this.element.classList.add('show');
    if (this.timer !== null) window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.element.classList.remove('show');
      this.timer = null;
    }, seconds * 1_000);
  }
}
